import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const echoUser = localStorage.getItem("echo_user");
    const navigate = useNavigate();

    useEffect(() => {
        if (!echoUser) return;

        const fetchNotifications = async () => {
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/echo_get_notifications.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: echoUser })
                });
                const data = await res.json();
                if (data.status === 'success') {
                    setNotifications(data.notifications || []);
                }
            } catch (error) {
                console.error("Chyba při načítání oznámení:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications();
    }, [echoUser]);

    if (loading) return <div className="text-center my-5">⏳ Načítání oznámení...</div>;

    return (
        <div className="container py-5 my-5">
            <h3 className="mb-4 text-danger"><i className="bi bi-bell-fill me-2"></i>Oznámení</h3>
            {notifications.length === 0 ? (
                <p className="text-muted">Nemáš žádná oznámení.</p>
            ) : (
                <div className="d-flex flex-column gap-3">
                    {notifications.map((notif, index) => (
                        <div
                            key={index}
                            className={`notif-card p-3 rounded shadow-sm ${notif.readed == 0 ? 'notif-unread' : 'notif-read'}`}
                            onClick={() => notif.path && navigate(notif.path)}
                            style={{ cursor: notif.path ? 'pointer' : 'default' }}
                        >
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="fw-bold mb-1 d-flex align-items-center">
                                        {notif.warn == 1 && <i className="bi bi-exclamation-triangle-fill text-danger me-2"></i>}
                                        {notif.m == 1 && <i className="bi bi-stars text-info me-2"></i>}
                                        <span className="text-dark">{notif.info}</span>
                                    </div>
                                    <small className="text-muted">{new Date(notif.created_at).toLocaleString('cs-CZ')}</small>
                                </div>
                                {notif.readed == 0 && (
                                    <span className="badge bg-danger">Nové</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Notifications;
